<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="300px" height="500px">
      <el-card :body-style="cardBodyStyle">
        <el-tree :data="dataTree" :props="defaultProps" node-key="id" :expand-on-click-node="false" highlight-current
          :default-expanded-keys="expandedKeys">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="() => handleConfirm(node, data)">
                选择
              </el-button>

            </span>
          </span>


        </el-tree>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    data() {
      return {
        cardBodyStyle: tools.style.card,
        dialogVisible: false,
        defaultProps: {
          children: 'children',
          label: 'menuName'
        },
        data: {},
        node: {},
        expandedKeys: [],
        dataTree: [],
      };
    },
    methods: {
      getDataTree() {
        var url = 'framework/SysMenu/queryAllMenu.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          if (this.dataTree.length == 1) {
            for (var node of this.dataTree) {
              this.expandedKeys.push(node.id)
            }
          }
        });

      },

      show() {
        this.getDataTree()
        this.dialogVisible = true
      },
      handleConfirm(node, data) {
        this.$emit('receiveFromChild', data);
        this.dialogVisible = false
      },
    }
  }
</script>

<style>
  .btn {
    padding-left: 15px;
  }


  .menu-tree-container {

    width: 20%;
    height: 100%;
    float: left;
    /* background: #e5e9f2; */
  }

  .menu-table-container {
    /* position: relative; */

    width: 60%;
    float: left;
    /* margin-right: 10px; */
    /* margin-top: -530px; */
    /* border: black 1px solid; */
  }

  .menu-button-container {
    /* position: relative; */

    width: 20%;
    float: right;
    /* margin-right: 10px; */
    /* margin-top: -530px; */
    /* border: black 1px solid; */
  }
</style>



// WEBPACK FOOTER //
// src/components/system/PopupMenuTree.vue